import { COUNTRY_CODES } from "@biggeo/bg-utils";
import startCase from "lodash/startCase";
import React from "react";
import ReactCountryFlag from "react-country-flag";
import { ClientRendered } from "../../components";
export const CountryIcon = ({ country, isClientRendered = true, }) => {
    var _a;
    const flag = (React.createElement(ReactCountryFlag, { className: "emojiFlag", countryCode: (_a = COUNTRY_CODES[startCase(country)]) !== null && _a !== void 0 ? _a : "CA" }));
    return isClientRendered ? React.createElement(ClientRendered, null, flag) : flag;
};
//# sourceMappingURL=CountryIcon.js.map